import { colors } from '../../partners/tokens'

export default {
  baseStyle: ({ colorScheme }: Record<string, any>) => ({
    borderWidth: 1,
    p: 0.5,
    _light: {
      bg: 'bg',
      borderColor: 'gray.600',
      backgroundColor: 'white',

      _checked: {
        borderColor: 'gray.600',
        // p: '1px',
        _icon: {
          color: `${colorScheme}.800`,
        },
      },

      _hover: {
        borderColor: 'gray.300',
      },

      _invalid: {
        borderColor: 'error.500',
        _text: {
          color: 'error.500',
        },
      },

      _stack: {
        space: 4,
        bgColor: 'bg',
        borderRadius: 'lg',
        px: 4,
        py: 3,
        width: 'full',
        borderWidth: 2,
        borderColor: 'bg',
      },

      _icon: {
        accessibilityHidden: true,
      },

      _focusVisible: {
        _stack: {
          borderWidth: 2,
          borderColor: 'primary.500',
        },
        style: {
          outlineWidth: '2px',
          outlineStyle: 'solid',
          outlineColor: colors.primary[500],
        },
      },
    },

    _invalid: {
      borderColor: 'error.500',
      _text: {
        color: 'error.500',
      },
    },
  }),
  sizes: {
    lg: { _icon: { size: 5 }, _text: { fontSize: 'lg' } },
    md: { _icon: { size: 4 }, _text: { fontSize: 'md' } },
    sm: { _icon: { size: 3 }, _text: { fontSize: 'sm' } },
  },
}
